import React from 'react';
import { legalLinks } from '../data/legal';
export function Footer() {
  return <footer id="site-footer" className="bg-brand-navy-deep px-4 pb-24 pt-10 text-center md:pb-10" data-id="element-95" data-mp="3gezcx2w41p0m">
      <div className="mx-auto max-w-6xl" data-id="element-96" data-mp="32o4ao9g4a660">
        <p className="text-sm font-bold tracking-wide text-white/90" data-id="element-97" data-mp="32p5kybpb6omo">MUSIQUE PRÊTE</p>
        <div className="mx-auto my-6 h-px max-w-sm bg-white/10" data-id="element-98" data-mp="36qhf8uj4ny17" />
        <ul aria-label="Informations légales" className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs text-white/70" data-id="element-99" data-mp="3ufa3s5xf73ls">
          {legalLinks.map(({
          label,
          href
        }, index) => <li key={label} className="flex items-center gap-3" data-id="element-100" data-mp="3ldalzbekzvhs" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" data-id="element-101" data-mp="3qcxbaj7op26y">·</span>}
              {href ? <a href={href} className="inline-flex min-h-[44px] items-center underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-102" data-mp="3qf9rorxsn4hw">
                  {label}
                </a> : <span data-id="element-103" data-mp="3gc0ffejw1k4z">{label}</span>}
            </li>)}
        </ul>
        <p className="mt-6 text-[11px] text-white/60" data-id="element-104" data-mp="3v8hp81cfiqpf">© 2026 MUSIQUE PRÊTE. Tous droits réservés.</p>
      </div>
    </footer>;
}